import React, { createContext, useState, useContext, useEffect } from "react";

// Criando o contexto
const AuthContext = createContext();

// Hook personalizado para acessar o contexto
export const useAuth = () => useContext(AuthContext);

// Provedor do contexto
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("access_token"));
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem("user_data")) || null); // Carrega cache local
    const [isLoadingUserData, setIsLoadingUserData] = useState(false); // Indicador de carregamento

    const API_URL = process.env.REACT_APP_API_URL || 'https://sic-conti-backend.vercel.app';


    // Função de login
    const login = (token) => {
        localStorage.setItem("access_token", token); // Salva o token
        setIsAuthenticated(true);
        fetchUserData(token); // Carrega os dados do usuário
    };

    // Função de logout
    const logout = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("user_data"); // Remove os dados do usuário
        setIsAuthenticated(false);
        setUserData(null); // Limpa os dados do usuário no estado
    };

    // Função para buscar os dados do usuário
    const fetchUserData = async (token) => {
        if (userData) return; // Evita chamadas se os dados já existirem no estado
        setIsLoadingUserData(true); // Inicia o carregamento
        const url = `${API_URL}/api/user-profile`;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem("user_data", JSON.stringify(data)); // Cacheia os dados no localStorage
                setUserData(data); // Salva no estado
            } else {
                console.error("Erro ao buscar os dados do usuário:", response.status);
                setUserData(null); // Limpa os dados em caso de erro
            }
        } catch (error) {
            console.error("Erro na requisição dos dados do usuário:", error);
            setUserData(null);
        } finally {
            setIsLoadingUserData(false); // Finaliza o carregamento
        }
    };

    // Buscar os dados do usuário ao carregar o contexto, caso autenticado
    useEffect(() => {
        const token = localStorage.getItem("access_token");
        if (token && !userData) {
            fetchUserData(token);
        }
    }, []); // Executa apenas uma vez

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, userData, isLoadingUserData }}>
            {children}
        </AuthContext.Provider>
    );
};
